var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"src":_vm.src,"type":"video/mp4","autoplay":"","loop":"","muted":"","playsinline":""},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }